<script setup lang="ts">
const props = defineProps<{
  label: {
    label?: string
    swatch?: string
  }
}>()

const labelValue = computed(() => props.label.label?.trim() || '')

const styles = computed(() => {
  return props.label.swatch?.startsWith('#')
    ? {
        'backgroundColor': props.label?.swatch || undefined,
        '--label-color': useContrastColor((props.label.swatch), 'var(--color-copy-reverse)', 'var(--color-copy-default)'),
      }
    : {}
})

const classes = computed(() => {
  return {
    label: true,
    [`label--${stringToSlug(props.label.label || '')}`]: true,
    [`label--${stringToSlug(props.label.swatch || '')}`]: props.label.swatch && !props.label.swatch?.startsWith('#'),
  }
})
</script>

<template>
  <span
    v-if="labelValue"
    :key="labelValue"
    :class="classes"
    :style="styles"
  >{{ labelValue }}</span>
</template>
